var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.255,
    height: 24.722,
    viewBox: "0 0 28.255 24.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-download-1000786",
    transform: "translate(-46.099 -115.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16453",
    "data-name": "Path 16453",
    d: "M74.353,121.857v-1.766a1.771,1.771,0,0,0-1.766-1.766H57.177a.569.569,0,0,1-.412-.171L54.51,115.9a1.774,1.774,0,0,0-1.248-.518h-5.4a1.767,1.767,0,0,0-1.766,1.766v4.709Z",
    transform: "translate(0 0)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16454",
    "data-name": "Path 16454",
    d: "M46.152,415.38v15.3a1.763,1.763,0,0,0,1.766,1.766H72.639a1.767,1.767,0,0,0,1.766-1.766v-15.3Zm11.213,7.894a.588.588,0,0,1,.832,0l1.492,1.492V418.2a.589.589,0,0,1,1.177,0v6.566l1.493-1.493a.589.589,0,0,1,.832.832l-2.5,2.5a.591.591,0,0,1-.833,0l-2.5-2.5a.588.588,0,0,1,0-.832Zm6.151,6.356H57.041a.589.589,0,1,1,0-1.177h6.475a.589.589,0,0,1,0,1.177Z",
    transform: "translate(-0.052 -292.346)",
    fill: "#2c53bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b81656d4ca705813437963fe1bd7cf57.svg";
export { ForwardRef as ReactComponent };